const imp = () => import(/* webpackChunkName: "ui_commont_icon"*/  "../sprite/loadSprite_rate");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-rate-circle": imp,
  "Icon-rate-cup": imp,
  "Icon-rate-heart": imp,
  "Icon-rate-lightning": imp,
  "Icon-rate-medal": imp,
  "Icon-rate-star": imp,
  "Icon-rate-praise": imp,
  "Icon-rate-sun": imp,
  "Icon-rate-fire": imp,
}
export default loadMap;